module.exports = __webpack_public_path__ + "img/argo.b8e10519.png";